<template>
  <div>
    <b-modal
      hide-footer
      id="modalVerParticipantes"
      title="Participantes Convidados"
      centered
      size="lg"
    >
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />

      <!-- Técnicos -->
      <ul class="list-group list-group-flush" v-if="participantes && participantes.length">
        <li class="list-group-item">
          <strong>Técnicos</strong>
        </li>
        <li
          class="list-group-item"
          v-for="participante in participantes"
          :key="participante.id"
        >
          {{ participante.nome }}
          <span class="d-block small text-muted">
            {{ participante.email_user || 'Sem e-mail informado' }}
          </span>
        </li>
      </ul>

      <!-- Outros Participantes -->
      <ul class="list-group list-group-flush" v-if="usuariosparticipantes && usuariosparticipantes.length">
        <li class="list-group-item">
          <strong>Outros Participantes</strong>
        </li>
        <b-table
          :items="usuariosparticipantes"
          :fields="[
            { key: 'nome', label: 'Nome' },
            { key: 'participacao', label: 'Participação' },
            { key: 'acoes', label: 'Ver prontuário' }
          ]"
          responsive
          small
          hover
          :busy="loading"
        >
          <template #cell(nome)="data">
            {{ data.item.nome }}
          </template>
          <template #cell(participacao)="data">
            <span class="text-muted">
              {{ participantesPresentes.includes(data.item.id) ? 'Presente' : participantesAusentes.includes(data.item.id) ? 'Ausente' : 'Não informado' }}
            </span>
          </template>
          <template #cell(acoes)="data">
            <b-link
              :to="'/dashboard/usuario/edit/' + data.item.id"
              target="_blank"
            >
              <i class="fas fa-external-link-alt"></i>
            </b-link>
          </template>
        </b-table>
      </ul>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalVerParticipantes",
  props: {
    participantes: Array,
    usuariosparticipantes: Array,
    loading: Boolean,
    participantesAusentes: Array,
    participantesPresentes: Array
  },
};
</script>
